import React, { useState, memo, useMemo } from 'react'
import MenuBrowser from './MenuBrowser'
import { motion } from 'framer-motion'
import {
  AMENITIES_AND_SETTINGS_LINKS,
  CLIENTELE_LINKS,
  CONDITIONS_TREATED_LINKS,
  TREATMENT_METHODS_LINKS,
  Containers
} from '../../../domain/useCases/navBar/constants'
import { NavSubItems } from './NavSubItems'
import { getNavBrowseAllProps } from '@/domain/useCases/navBar/getNavBrowseAllProps'
import { NavBrowseButton } from './NavBrowseButton'

const conVariants = {
  hidden: {
    opacity: 0,
    translateX: '300px',
    transition: {
      duration: 0.2,
      delay: 0.5
    }
  },
  animate: {
    opacity: 1,
    translateX: '0px',
    transition: {
      duration: 0.2
    }
  },
  exit: {
    opacity: 0,
    translateX: '300px',
    transition: {
      duration: 0.2
    }
  }
}

const MENUS_TO_HIDE = ['Find Treatment', 'Settings', 'Clientele']

const TreatmentMenu = ({ setPage, container }) => {
  const [state, setState] = useState({ open: null })
  const setOpen = (id) => {
    if (state.open === id) {
      setState({ open: null })
    } else {
      setState({
        open: id
      })
    }
  }

  const containerContent = useMemo(() => {
    if (!container) return null
    switch (container) {
      case Containers.AMENITIES_AND_SETTINGS:
        return (
          <NavSubItems
            key={container}
            className="mb-8 pt-6 [&_a]:text-gray-800 [&_li]:text-gray-800"
            toggleOpen={setOpen}
            label={container}
            currentlyOpen={state.open}
            itemGroups={AMENITIES_AND_SETTINGS_LINKS.itemGroups}
            shouldShowLabel={false}
          />
        )
      case Containers.CONDITIONS:
        return (
          <div className="mb-8">
            <h2 className="flex items-center py-4 !text-xl !font-medium leading-8 !text-gray-1100">
              Conditions
            </h2>

            <NavSubItems
              key={container}
              toggleOpen={setOpen}
              label={container}
              currentlyOpen={'Conditions'}
              items={CONDITIONS_TREATED_LINKS.items}
              shouldShowLabel={false}
            />
          </div>
        )
      case Containers.TREATMENT_METHODS:
        return (
          <div className="mb-8">
            <h2 className="flex items-center py-4 !text-xl !font-medium leading-8 !text-gray-1100">
              Treatment Methods
            </h2>

            <NavSubItems
              key={container}
              toggleOpen={setOpen}
              label={container}
              currentlyOpen={'Treatment Methods'}
              itemGroups={TREATMENT_METHODS_LINKS.itemGroups}
              shouldShowLabel={false}
            />
          </div>
        )
      case Containers.CLIENTELE:
        return (
          <div className="mb-8">
            <h2 className="flex items-center py-4 !text-xl !font-medium leading-8 !text-gray-1100">
              Clientele
            </h2>

            <NavSubItems
              key={container}
              toggleOpen={setOpen}
              label={container}
              currentlyOpen={'Clientele'}
              items={CLIENTELE_LINKS.items}
              shouldShowLabel={false}
            />
          </div>
        )
    }
  }, [container])

  const browseAllLabel = getNavBrowseAllProps(container)

  return (
    <motion.div
      key="treatment-menu"
      variants={conVariants}
      initial="hidden"
      animate="animate"
    >
      <div className="h-full overflow-y-auto overflow-x-clip bg-white px-6 pb-24">
        <MenuBrowser setPage={setPage} />
        {containerContent}

        {!MENUS_TO_HIDE.includes(container) && (
          <NavBrowseButton {...browseAllLabel} />
        )}
      </div>
    </motion.div>
  )
}

export default memo(TreatmentMenu)
